<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Schedule K Attachment Required
    </h2>
    <mat-dialog-content class="mat-typography">
        Please attach a waiver. Either the Construction Date exceeds the
        Construct By Date, or the 15-day grace period for filing the Notice of
        Construction has passed.
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="p-5">
        <button
            id="okay-button"
            color="primary"
            type="button"
            mat-button
            mat-raised-button
            mat-dialog-close
            cdkFocusInitial
            (click)="close()"
        >
            OK
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
